window.Parsley.addValidator('validCard', {
    validateString: function(value) {
        var cardType = getCardType(value);
        if(cardType) {
            return true;
        }
        return false;
    },
    messages: {
        en: 'Card type is invalid.'
    }
});

window.Parsley.addValidator('validCvc', {
    validateString: function(value, requirement) {
        var cardType, regex;

        cardType = getCardType(document.querySelector(requirement).value);
        if(!cardType) return false;

        regex = new RegExp('^[0-9]{'+cardType.cvv+'}$');
        return regex.test(value);
    },
    messages: {
        en: 'Security code is invalid.'
    }
});

window.Parsley.addValidator('validExpiration', {
    validateString: function(value, requirement) {
        var year         = Number(value);
        var month        = Number(document.querySelector(requirement).value);
        var currentMonth = new Date().getMonth() + 1;
        var currentYear  = new Date().getFullYear();

        if(isNaN(month) || isNaN(year)) {
            return false;
        }

        if(year === currentYear && month < currentMonth) {
            return false;
        }

        if(month < 1 || month > 12) {
            return false;
        }

        return !(year < currentYear);
    },
    messages: {
        en: 'Card expiration is invalid.'
    }
});

window.Parsley.addValidator('requiredIf', {
    validateString: function(value, requirement) {
        var requirements = requirement.split(',').map(function(item, i){
            var obj = {};
            var opt = item.split(':');
            obj[opt[0]] = opt[1];

            return obj;
        });
    },
    messages: {
        en: 'This value is required.'
    }
});

// window.Parsley.addValidator('recaptchaChecked', {
//     validateString: function(_ignoreValue) {
//         return (grecaptcha && grecaptcha.getResponse().length !== 0);
//     },
//     messages: {
//         en: 'Please complete the reCaptcha challenge before submitting.'
//     }
// });